export const useMyFetch = <T>(request, opts) => {
  const config = useRuntimeConfig();
  return useFetch<T>(request, {
    baseURL: config.public.baseUrl,
    // Détecter ApiResponse<T> (status + message + data) ou retourner brut (rétrocompatibilité)
    transform: (raw: any) => {
      if (
        raw != null &&
        typeof raw === 'object' &&
        'status' in raw &&
        'message' in raw &&
        'data' in raw
      ) {
        return raw.data as T;
      }
      return raw as T;
    },
    ...opts,
  });
};
